import { render, staticRenderFns } from "./ServiceProject.vue?vue&type=template&id=463b82fe&scoped=true&"
import script from "./ServiceProject.vue?vue&type=script&lang=js&"
export * from "./ServiceProject.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProject.vue?vue&type=style&index=0&id=463b82fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b82fe",
  null
  
)

export default component.exports